import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {minDate} from "../../Constants/Constants"
const AddTripDetails = ({ formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [vehicle, setVehicle] = useState([]);
  const [Company, setCompany] = useState([]);
  const [Staff, setStaff] = useState([]);
  // console.log(Material)
  const [rowAddData, setRowAddData] = useState({
    start_reading: 0,
    location_reading: 0,
    return_reading: 0,
    start_date: "",
    departure_datetime: null,
    end_date: "",
    return_datetime: null,
    return_location: "",
    trip_status: "",
    driver_name: "",
    advance_pay: 0,
    unloading_charges: 0,
    da_amount: 0,
    toll_tax: 0,
    grease: 0,
    air_puncture: 0,
    miscellaneous: 0,
    remarks: "",
    refuel_place: "",
    reading_refuel_place: 0,
    diesel_ltr: 0,
    running: 0,
    rate: 0,
  });
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedStafflId, setSelectedStaffId] = useState("");
  function resetFileds() {
    setRowAddData({
      start_reading: 0,
      location_reading: 0,
      return_reading: 0,
      start_date: "",
      departure_datetime: null,
      end_date: "",
      return_datetime: null,
      return_location: "",
      trip_status: "",
      driver_name: "",
      advance_pay: 0,
      unloading_charges: 0,
      da_amount: 0,
      toll_tax: 0,
      grease: 0,
      air_puncture: 0,
      miscellaneous: 0,
      remarks: "",
      refuel_place: "",
      reading_refuel_place: 0,
      diesel_ltr: 0,
      running: 0,
      rate: 0,
    });
    setSelectedStaffId("");
    setSelectedVehicleId("");
    setSelectedCompanyId("");
  }

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setSelectedStaffId(e.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };
  const handleDateChange = (name, date) => {
    const formattedDate = date
      ? moment(date).format("YYYY-MM-DD hh:mm:ss A")
      : "";
    setRowAddData({ ...rowAddData, [name]: formattedDate });
  };
  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      start_reading,
      location_reading,
      return_reading,
      start_date,
      departure_datetime,
      end_date,
      return_datetime,
      return_location,
      trip_status,
      driver_name,
      advance_pay,
      unloading_charges,
      da_amount,
      toll_tax,
      grease,
      air_puncture,
      miscellaneous,
      remarks,
      refuel_place,
      reading_refuel_place,
      diesel_ltr,
      running,
      rate,
    } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/trips/trips/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        vehicle_id: selectedVehicleId,
        start_reading,
        location_reading,
        return_reading,
        start_date: moment(start_date).format("YYYY-MM-DD"),
        departure_datetime,
        end_date: end_date ? moment(end_date).format("YYYY-MM-DD") : null,
        return_datetime,
        return_location,
        trip_status,
        driver_name,
        advance_pay,
        unloading_charges,
        da_amount,
        toll_tax,
        grease,
        air_puncture,
        miscellaneous,
        refuel_place,
        reading_refuel_place,
        diesel_ltr,
        running,
        rate,
        remarks,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        resetFileds();
        getData();
      }, 1000);
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  // const getStaff = async (e) => {
  //   // console.log(e.target.value)
  //   setSelectedCompanyId(e.target.value);
  //   const companyID = e.target.value;
  //   const BASE_URL =
  //     SERVER_URL +
  //     `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${companyID}`;
  //   const res = await fetch(BASE_URL, {
  //     method: "GET",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //   });
  //   const result = await res.json();
  //   setStaff(result.data);
  // };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Trip Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_name">
                              Start Point/Location
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) =>
                                setSelectedCompanyId(e.target.value)
                              }
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {Company &&
                                Company?.length > 0 &&
                                Company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="staff_id">Driver Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleStaffChange}
                              value={selectedStafflId}
                              id="staff_id"
                              required
                            >
                              <option value="">Select Driver Name</option>
                              {Staff &&
                                Staff?.length > 0 &&
                                Staff?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option
                                        value={item.id}
                                      >{`${item.staff_name}`}</option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="material_name">
                              Vehicle Number
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleVehicleChange}
                              value={selectedVehicleId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.vehicle_number}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="return_location">
                              Return Point/Location
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="return_location"
                              id="return_location"
                              placeholder="Return Point/Location"
                              onChange={handleChange}
                              value={rowAddData.return_location}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="battery_num">Start Reading</label>
                            <input
                              type="number"
                              className="form-control"
                              name="start_reading"
                              id="start_reading"
                              placeholder="Start Reading"
                              onChange={handleChange}
                              value={rowAddData.start_reading}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="location_reading">
                              Location reading
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="location_reading"
                              id="location_reading"
                              placeholder="Location Reading"
                              onChange={handleChange}
                              value={rowAddData.location_reading}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="return_reading">
                              Return Reading
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="return_reading"
                              id="return_reading"
                              placeholder="Return Reading"
                              onChange={handleChange}
                              value={rowAddData.return_reading}
                              required
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="trip_status">Trip Status</label>
                            <select
                              className="form-control form-control-lg"
                              name="trip_status"
                              id="trip_status"
                              onChange={handleChange}
                              value={rowAddData.trip_status}
                              required
                            >
                              <option value="">Select Status</option>
                              <option value="ongoing">On-going</option>
                              <option value="completed">Completed</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="start_date">Start Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="start_date"
                              id="start_date"
                              onChange={handleChange}
                              value={rowAddData.start_date}
                              max={new Date().toISOString().split("T")[0]}
                              required
                              min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="departure_datetime">
                              Departure Date Time
                            </label>
                            {/* <input
                              type="date"
                              className="form-control"
                              name="departure_datetime"
                              id="departure_datetime"
                              placeholder="Departure Datetime"
                              onChange={handleChange}
                              value={rowAddData.departure_datetime}
                            /> */}
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DateTimePicker
                                // label={"Select in 24hr Format"}
                                className="form-control date-control"
                                name="departure_datetime"
                                id="departure_datetime"
                                maxDate={moment()}
                                minDate={moment(minDate)}
                                format="YYYY-MM-DD hh:mm:ss A"
                                // ampm={false}
                                timeSteps={{ hours: 1, minutes: 1 }}
                                value={
                                  rowAddData.departure_datetime
                                    ? moment(
                                        rowAddData.departure_datetime,
                                        "YYYY-MM-DD hh:mm:ss A"
                                      )
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange("departure_datetime", date)
                                }
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="end_date">End Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="end_date"
                              id="end_date"
                              placeholder="End Date"
                              onChange={handleChange}
                              value={rowAddData.end_date}
                              min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="return_datetime">
                              Return Date Time
                            </label>
                            {/* <input
                              type="date"
                              className="form-control"
                              name="return_datetime"
                              id="return_datetime"
                              placeholder="Return Datetime"
                              onChange={handleChange}
                              value={rowAddData.return_datetime}
                            /> */}
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DateTimePicker
                                // label={"Select in 24hr Format"}
                                className="form-control date-control"
                                name="return_datetime"
                                id="return_datetime"
                                format="YYYY-MM-DD hh:mm:ss A"
                                minDate={moment(minDate)}
                                // ampm={false}
                                timeSteps={{ hours: 1, minutes: 1 }}
                                value={
                                  rowAddData.return_datetime
                                    ? moment(
                                        rowAddData.return_datetime,
                                        "YYYY-MM-DD hh:mm:ss A"
                                      )
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange("return_datetime", date)
                                }
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="driver_name">Driver Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="driver_name"
                              id="driver_name"
                              placeholder="Driver Name"
                              onChange={handleChange}
                              value={rowAddData.driver_name}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="advance_pay">Advance Pay</label>
                            <input
                              type="number"
                              className="form-control"
                              name="advance_pay"
                              id="advance_pay"
                              placeholder="Advance Pay"
                              onChange={handleChange}
                              value={rowAddData.advance_pay}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="unloading_charges">
                              Unloading Charges
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="unloading_charges"
                              id="unloading_charges"
                              placeholder="Unloading Charges"
                              onChange={handleChange}
                              value={rowAddData.unloading_charges}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="da_amount">DA Amount</label>
                            <input
                              type="number"
                              className="form-control"
                              name="da_amount"
                              id="da_amount"
                              placeholder="DA Amount"
                              onChange={handleChange}
                              value={rowAddData.da_amount}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="toll_tax">Toll Tax</label>
                            <input
                              type="number"
                              className="form-control"
                              name="toll_tax"
                              id="toll_tax"
                              placeholder="Toll Tax"
                              onChange={handleChange}
                              value={rowAddData.toll_tax}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="grease">Grease</label>
                            <input
                              type="number"
                              className="form-control"
                              name="grease"
                              id="grease"
                              placeholder="Grease"
                              onChange={handleChange}
                              value={rowAddData.grease}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="air_puncture">Air/Puncture</label>
                            <input
                              type="number"
                              className="form-control"
                              name="air_puncture"
                              id="air_puncture"
                              placeholder="Air Puncture"
                              onChange={handleChange}
                              value={rowAddData.air_puncture}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="miscellaneous">Miscellaneous</label>
                            <input
                              type="number"
                              className="form-control"
                              name="miscellaneous"
                              id="miscellaneous"
                              placeholder="Miscellaneous"
                              onChange={handleChange}
                              value={rowAddData.miscellaneous}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <textarea
                              className="form-control"
                              name="remarks"
                              id="remarks"
                              placeholder="Enter any additional details"
                              rows="2"
                              style={{ resize: "both" }}
                              onChange={handleChange}
                              value={rowAddData.remarks}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="refuel_place">Refuel Place</label>
                            <input
                              type="text"
                              className="form-control"
                              name="refuel_place"
                              id="refuel_place"
                              placeholder="Refuel Place"
                              onChange={handleChange}
                              value={rowAddData.refuel_place}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="reading_refuel_place">
                              Reading Refuel Place
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="reading_refuel_place"
                              id="reading_refuel_place"
                              placeholder="Reading at refuel place"
                              onChange={handleChange}
                              value={rowAddData.reading_refuel_place}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="diesel_ltr">Diesel (in Ltr.)</label>
                            <input
                              type="number"
                              className="form-control"
                              name="diesel_ltr"
                              id="diesel_ltr"
                              placeholder="Diesel in ltr."
                              onChange={handleChange}
                              value={rowAddData.diesel_ltr}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="rate">Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="rate"
                              id="rate"
                              placeholder="Rate"
                              onChange={handleChange}
                              value={rowAddData.rate}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="running">Running (in Km)</label>
                            <input
                              type="number"
                              className="form-control"
                              name="running"
                              id="running"
                              placeholder="Running"
                              onChange={handleChange}
                              value={rowAddData.running}
                              min="0"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTripDetails;
